var StatsExtras = require('../vendor/rStats.extras')
var Stats = require('../vendor/rStats')

module.exports = function createStats( env ) {
	
	// Description: http://spite.github.io/rstats/
	// Github: https://github.com/spite/rstats
	// Demo: http://spite.github.io/rstats/demo.html
	
	// if( process.env.NODE_ENV === "development" ) {
	if( false ) {
		
		var stats = new Stats({
			CSSPath : "assets/vendor/"
		})
		return stats
		
	} else {
		
		var api = {
			set : function() {},
			start : function() {},
			tick : function() {},
			end : function() {},
			frame : function() {},
			value : function() {},
			draw : function() {},
			update : function() {},
		}
		
		var stub = function() {
			return api
		}
		
		return stub
	}
}